module.exports = __webpack_public_path__ + "img/1.a252baa0.png";